import {
  IsNumber
} from 'class-validator';

/**
 * Validation request for checking if employee has operator access to POS Device.
 */
export class PosValidateOperatorEmployeeIdRequestDto {
  /**
   * Operator Employee Id
   */
   @IsNumber()
   public operatorEmployeeId: number;

  /**
   * POS Device Id
   */
  @IsNumber()
  public posDeviceId: number;

  constructor(operatorEmployeeId: number, posDeviceId: number) {
    this.operatorEmployeeId = operatorEmployeeId;
    this.posDeviceId = posDeviceId;
  }
}
